module.exports = __webpack_public_path__ + "static/media/TrackStatus.addc9cc5.gif";